import Text from '@basicComponents/text';
import theme from '@/style';
import React, {Component} from 'react';
import {
  ImageURISource,
  FlatList,
  View,
  NativeSyntheticEvent,
  NativeScrollEvent,
  LayoutChangeEvent,
} from 'react-native';
import HomeFloorTitleBox from './home-floor-title-box';

interface HomeFloorBoxProps<listItemT> {
  /** 数据列表 */
  list: listItemT[];
  /** 渲染item,会返回数据列表的项,以及index */
  renderItem: (item: listItemT, index: number) => React.ReactElement;
  title: string;
  /** 标题背景图 */
  titleBgImg?: ImageURISource;
  titleIcon: ImageURISource;
  titleIconSize?: number;
  /** 每个元素的宽度,这个加上偏移量为每次拖动的距离 */
  itemWidth: number;
  /** 偏移量(中间padding的距离,默认theme.paddingSize.l) */
  offsetSize?: number;
  /** 当点击viewAll时触发的方法,如果不传,不会显示viewAll的按钮 */
  onPressViewAll?: () => void;
}

class HomeFloorBox<listItemT> extends Component<
  HomeFloorBoxProps<listItemT>,
  {
    leftDisabled: boolean;
    rightDisabled: boolean;
    currentIndex: number;
    lastOffset: number;
    /** 滚动区域一屏的宽度 */
    listLayoutWidth: number;
    /** 偏移量(中间padding的距离,默认theme.paddingSize.s) */
    offsetSize: number;
  }
> {
  constructor(props: HomeFloorBoxProps<listItemT>) {
    super(props);
    this.state = {
      leftDisabled: true,
      rightDisabled: false,
      currentIndex: 0,
      lastOffset: 0,
      listLayoutWidth: 0,
      offsetSize: props.offsetSize || theme.paddingSize.s,
    };
  }
  flatListRef = React.createRef<FlatList>();
  handleScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const {contentOffset, layoutMeasurement, contentSize} = event.nativeEvent;
    this.setState(() => ({
      leftDisabled: contentOffset.x === 0,
      rightDisabled:
        Math.floor(contentOffset.x + layoutMeasurement.width) >=
        Math.floor(contentSize.width),
      lastOffset: contentOffset.x,
    }));
  };
  layoutList = (event: LayoutChangeEvent) => {
    event.persist && event.persist();
    this.setState(() => ({
      listLayoutWidth: event.nativeEvent.layout.width,
    }));
  };
  scrollListTo = (type: 1 | -1) => {
    this.scrollListToOffsetX(
      this.state.lastOffset +
        (this.state.listLayoutWidth + this.state.offsetSize) * type,
    );
  };
  scrollListToOffsetX = (num: number) => {
    this.flatListRef.current!.scrollToOffset({
      animated: true,
      offset: Math.round(num),
    });
  };
  render() {
    const {list, renderItem, title} = this.props;
    return (
      <View style={[theme.fill.fillW, theme.flex.col]}>
        <HomeFloorTitleBox style={[theme.fill.fillW]}>
          <View
            style={[
              theme.flex.row,
              theme.flex.centerByCol,
              // eslint-disable-next-line react-native/no-inline-styles
              {
                height: 36,
                marginTop: -12,
              },
            ]}>
            <Text size="large" white fontFamily="fontInter">
              {title}
            </Text>
          </View>
        </HomeFloorTitleBox>
        <View style={[theme.margin.btml, theme.flex.row, theme.flex.wrap]}>
          {list.map((item, index) => renderItem(item, index))}
        </View>
      </View>
    );
  }
}

export default HomeFloorBox;
